import { render, staticRenderFns } from "./addGeometry.vue?vue&type=template&id=520bb3cd&scoped=true&"
import script from "./addGeometry.vue?vue&type=script&lang=js&"
export * from "./addGeometry.vue?vue&type=script&lang=js&"
import style0 from "./addGeometry.vue?vue&type=style&index=0&id=520bb3cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520bb3cd",
  null
  
)

export default component.exports